import { Fragment } from "react";
import './LinkButton.scss';
import { HelperWebView } from "../../../core/services/helper/helper.service";

interface LinkButtonProps {
  styleClass?: string,
  textClass?: string,
  valueText?: string,
  valueLink?: string,
  icon?: string,
  isMailTo?: boolean,
  isPhone?: boolean,
  isMaps?: boolean,
  darkMode?: boolean,
  isDetailsCard?: boolean,
  onClick: () => void
}
const LinkButton = (props: LinkButtonProps) => {
  const { styleClass, textClass, valueText, icon,
    valueLink, isMailTo, isPhone, isMaps, isDetailsCard } = props;

  const renderIcon = () => {
    if (icon) {
      return (
        <img src={icon} alt="icon-link" className="me-1" />
      );
      //className={`icon-link me-1 ${darkMode ? 'dark-mode' : ''}`} />
      
    }
    return <Fragment />;
  };

  const renderLink = () => {
    if (valueLink) {
      let externalLink = `mailto:${valueLink}`;
      if (!isMailTo) {
        externalLink = /^https?:\/\//.test(valueLink) ? valueLink : `http://${valueLink}`;
      }
      if (isPhone) {
        externalLink = `tel:${valueLink}`;
      }

      if (isMaps) {
        if(HelperWebView.isIOS() || HelperWebView.isIOSWebview()) {externalLink= `http://maps.apple.com/?q=${encodeURIComponent(valueLink)}`;}
        else{ externalLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(valueLink)}`;}
      }

      return (
        <a className="link-container" target="_blank" rel="noreferrer" href={externalLink}>
          <span className={`link-container-span ${isDetailsCard ? "details" : ""} ${textClass || ''}`}>{valueText}</span>
        </a>
      );
    }

    return (
      <span className={`link-container-span ${textClass || ''}`}>{valueText}</span>
    );
  };

  return (
    <div className={styleClass} onClick={props.onClick}>
        {renderIcon()}
        {renderLink()}
    </div>
  );
}

export default LinkButton;